import { ReportBetMobileType } from "app/types/reportType";
import SettledBet from "./SettledBet";
type Props = {
  bets: ReportBetMobileType[];
  tab: string;
};

const SettledBets: React.FC<Props> = ({ bets, tab }) => {
  return (
    <div>
      {bets.map((bet: any, index: number) => {
        return <SettledBet bet={bet} key={index} index={index} tab={tab} />;
      })}
    </div>
  );
};

export default SettledBets;
